export default __webpack_public_path__ + "static/media/profile_placeholder.814cb3e1.png";